// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/transportation/flight.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/feature/transportation/flight.proto.
 */
export const file_proto_model_feature_transportation_flight = /*@__PURE__*/
  fileDesc("Ci9wcm90by9tb2RlbC9mZWF0dXJlL3RyYW5zcG9ydGF0aW9uL2ZsaWdodC5wcm90bxIGY2FybWVuIiYKCEFpcmNyYWZ0EgwKBGNvZGUYASABKAkSDAoEbmFtZRgCIAEoCSIlCgdBaXJsaW5lEgwKBGNvZGUYASABKAkSDAoEbmFtZRgCIAEoCSJACgxGbGlnaHROdW1iZXISIAoHYWlybGluZRgBIAEoCzIPLmNhcm1lbi5BaXJsaW5lEg4KBm51bWJlchgCIAEoCSLFAQoURmxpZ2h0U2VnbWVudERldGFpbHMSJwoLY2FiaW5fY2xhc3MYASABKA4yEi5jYXJtZW4uQ2FiaW5DbGFzcxIiCghhaXJjcmFmdBgCIAEoCzIQLmNhcm1lbi5BaXJjcmFmdBIvChFvcGVyYXRpbmdfY2FycmllchgDIAEoCzIULmNhcm1lbi5GbGlnaHROdW1iZXISLwoRbWFya2V0aW5nX2NhcnJpZXIYBCABKAsyFC5jYXJtZW4uRmxpZ2h0TnVtYmVyKpQBCgpDYWJpbkNsYXNzEhsKF0NBQklOX0NMQVNTX1VOU1BFQ0lGSUVEEAASFwoTQ0FCSU5fQ0xBU1NfRUNPTk9NWRABEh8KG0NBQklOX0NMQVNTX1BSRU1JVU1fRUNPTk9NWRACEhgKFENBQklOX0NMQVNTX0JVU0lORVNTEAMSFQoRQ0FCSU5fQ0xBU1NfRklSU1QQBEI/Wj1naXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9mZWF0dXJlL3RyYW5zcG9ydGF0aW9uYgZwcm90bzM");

/**
 * Describes the message carmen.Aircraft.
 * Use `create(AircraftSchema)` to create a new message.
 */
export const AircraftSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight, 0);

/**
 * Describes the message carmen.Airline.
 * Use `create(AirlineSchema)` to create a new message.
 */
export const AirlineSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight, 1);

/**
 * Describes the message carmen.FlightNumber.
 * Use `create(FlightNumberSchema)` to create a new message.
 */
export const FlightNumberSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight, 2);

/**
 * Describes the message carmen.FlightSegmentDetails.
 * Use `create(FlightSegmentDetailsSchema)` to create a new message.
 */
export const FlightSegmentDetailsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight, 3);

/**
 * Describes the enum carmen.CabinClass.
 */
export const CabinClassSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_transportation_flight, 0);

/**
 * @generated from enum carmen.CabinClass
 */
export const CabinClass = /*@__PURE__*/
  tsEnum(CabinClassSchema);

